import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React from 'react';
import FilterFlow, { FilterFlowDataProps } from '../FilterFlow';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import componentConstants from '../../../core-utils/messages/componentConstants';

interface PreviewResultsProps {
  data: FilterFlowDataProps[];
  isLoading: boolean;
}

const useStyles = makeStyles()({
  previewResults: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    alignItems: 'center',
  },
});

export const PreviewResults = ({ data, isLoading }: PreviewResultsProps) => {
  const messages = componentConstants.ORGANISMS.COHORT_DETAILS;

  const { classes } = useStyles();
  return (
    <Box className={classes.previewResults}>
      <Typography
        fontSize="16px"
        fontType="medium"
        lineHeight="24px"
        textColor={patientAccessTheme.palette.grey[900]}
      >
        {messages.PREVIEW_RESULTS}
      </Typography>
      <FilterFlow data={data} isLoading={isLoading} />
    </Box>
  );
};
